<template>
    <!--網站路徑導覽(麵包屑)-->
    <div class="sitemap">
        <!--首頁-->
        <span>
            <a href="/EN" >
                Home
            </a>
        </span>
        <!--分類路徑(主分類/次分類or標題/第三分類or標題)-->
        <span v-for="(itme,index) in List" :key="index">
            / <a :href="itme.url == ''?'javascript:void(0)': itme.url" v-if="itme.text != '' &&itme.text != null">
                {{itme.text}}
            </a>
        </span>
    </div>
</template>
<script>
export default{
    data(){
        return{
            //網站路徑
            List:[],
        };
    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "sider"(){
            //初始化
            this.init();
        },
    },
    props:["sider"],
    methods:{
        //初始化
        init() {
            this.List=[];
            if(this.sider.list != null){
                this.List = this.sider.list;
            }
        },
    },
};
</script>
